import { render } from "./DocumentsFromAttorney.vue?vue&type=template&id=4ee76bbf"
import script from "./DocumentsFromAttorney.vue?vue&type=script&lang=js"
export * from "./DocumentsFromAttorney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__